import Swiper from 'swiper/bundle';
/*
    Swiper JS functions:
    1. slidesPerView: Number of slides visible at a time.
    2. spaceBetween: Gap between each slide.
    3. loop: Enables infinite scrolling of slides.
    4. breakpoints: Define different settings for various viewport widths.
    5. navigation: Enable previous and next buttons.
    6. pagination: Adds a pagination element (dots) for navigation.
    7. autoplay: Automatically transition slides after a delay.
    8. effect: Apply different slide effects such as fade, cube, flip, etc.
    9. grabCursor: Changes the cursor to a "grab" icon on hover.
    10. keyboard: Enable keyboard navigation for slides.
    11. mousewheel: Enable mouse wheel interaction for scrolling.
    12. scrollbar: Add a draggable scrollbar for navigation.
    13. on: Define event listeners like `init`, `slideChange`, `reachEnd`, etc.

    new Swiper('.swiper', {
        pagination: {
            el: '.swiper-pagination', // Class for pagination
            clickable: true, // Pagination dots are clickable
        },
        autoplay: {
            delay: 5000, // Auto-slide every 5 seconds
            disableOnInteraction: false, // Continue autoplay after interaction
        },
        effect: 'fade', // Slide transition effect (e.g., 'slide', 'fade', 'cube', 'coverflow', 'flip')
        grabCursor: true, // Show grab cursor on hover
        keyboard: {
            enabled: true, // Allow keyboard navigation
            onlyInViewport: true, // Only enable in the viewport
        },
        mousewheel: {
            invert: false, // Invert mousewheel scroll direction
        },
        scrollbar: {
            el: '.swiper-scrollbar', // Class for scrollbar
            draggable: true, // Allow dragging the scrollbar
        },
        on: {
            // Events example
            init: function () {
                console.log('Swiper initialized');
            },
            slideChange: function () {
                console.log('Slide changed to index:', this.activeIndex);
            },
            reachEnd: function () {
                console.log('Reached the end of slides');
            },
            autoplayStart: function () {
                console.log('Autoplay started');
            },
            autoplayStop: function () {
                console.log('Autoplay stopped');
            },
        }
    }
*/

var $ = jQuery;

function initializeMoreWorkSwiper() {
    const containerPaddingLeft = parseFloat($('.container').css('padding-left')) || 0;

    if ($('.more-work-swiper').length > 0) {
        // Destroy existing instance if it exists (for resize)
        if (window.moreWorkSwiperInstance) {
            window.moreWorkSwiperInstance.destroy(true, true);
        }

        // Count the number of slides and add class if 3 or more
        const slideCount = $('.more-work-swiper .swiper-slide').length;
        if (slideCount >= 3) {
            $('.more-work-swiper').addClass('has-enough-slides');
        } else {
            $('.more-work-swiper').removeClass('has-enough-slides');
        }

        window.moreWorkSwiperInstance = new Swiper('.more-work-swiper', {
            loop: false,
            slidesPerView: 1.4, // Let slide width determine visibility
            spaceBetween: 16,
            centeredSlides: false,
            slidesOffsetBefore: containerPaddingLeft, // Use container padding as offset
            breakpoints: {
                // Adjust spaceBetween for different breakpoints if needed
                768: {
                    spaceBetween: 24,
                    slidesPerView: 2.4,
                },
                1024: {
                    spaceBetween: 24,
                    slidesPerView: 2.4,
                }
            },
            navigation: {
                nextEl: ".more-work-section .swiper-button-next",
                prevEl: ".more-work-section .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            grabCursor: true,
        });
    }
}

// Initialize Media Carousel
function initializeMediaCarousel() {
    if ($('.media-carousel-swiper').length > 0) {
        // Destroy existing instance if it exists (for resize)
        if (window.mediaCarouselInstance) {
            window.mediaCarouselInstance.destroy(true, true);
        }

        // Get container max-width for proper sizing
        const containerMaxWidth = 1728; // Max width from CSS
        const windowWidth = window.innerWidth;

        // Calculate slide width to be slightly less than container width
        // This ensures the main slide stays within container limits
        const mainSlideWidth = Math.min(windowWidth, containerMaxWidth) * 0.85;

        window.mediaCarouselInstance = new Swiper('.media-carousel-swiper', {
            loop: false,
            slidesPerView: 'auto', // Allow variable width slides
            spaceBetween: 12,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                768: {
                    spaceBetween: 16,
                },
                1024: {
                    spaceBetween: 24,
                }
            },
            on: {
                init: function () {
                    // Set width for all slides on initialization
                    document.querySelectorAll('.media-carousel-swiper .swiper-slide').forEach(slide => {
                        slide.style.width = `${mainSlideWidth}px`;
                    });
                },
            },
            navigation: {
                nextEl: ".media-carousel-swiper .swiper-button-next",
                prevEl: ".media-carousel-swiper .swiper-button-prev",
            },
            allowTouchMove: true,
            keyboard: {
                enabled: true,
            },
            grabCursor: true,
            on: {
                slideChange: function () {
                    // Pause ALL videos when changing slides

                    // Pause all Vimeo videos when changing slides
                    document.querySelectorAll('.media-carousel-iframe').forEach(function (iframe) {
                        // Get the container containing this iframe
                        const container = iframe.closest('.media-carousel-item');

                        if (container && iframe.src && iframe.src.includes('vimeo.com')) {
                            // Use Vimeo's postMessage API to pause the video
                            try {
                                iframe.contentWindow.postMessage(JSON.stringify({
                                    method: 'pause'
                                }), '*');

                                // Update the playing state
                                container.dataset.playing = 'false';
                            } catch (e) {
                                console.error('Error pausing Vimeo video:', e);
                            }

                            // For non-active slides, completely unload the iframe and reset the state
                            const slide = iframe.closest('.swiper-slide');
                            const isActiveSlide = slide && slide.classList.contains('swiper-slide-active');

                            if (!isActiveSlide) {
                                // Reset the iframe
                                iframe.src = '';
                                iframe.style.display = 'none';

                                // Reset the video state to allow replaying when returning to this slide
                                container.classList.remove('video-manually-played');
                                container.classList.remove('video-auto-played');

                                // Reset the data attributes
                                container.dataset.playing = 'false';

                                // Show the thumbnail and play button again
                                const img = container.querySelector('img');
                                const playBtn = container.querySelector('.media-carousel-play');
                                const overlay = container.querySelector('.bg-opacity-60');

                                if (img) img.style.display = '';
                                if (playBtn) playBtn.style.display = '';
                                if (overlay) overlay.style.display = '';

                                // Remove any click overlays that might have been added
                                const clickOverlay = container.querySelector('.video-click-overlay');
                                if (clickOverlay) {
                                    clickOverlay.remove();
                                }

                                // Reset the click listener flag
                                if (iframe.hasAttribute('data-click-listener')) {
                                    iframe.removeAttribute('data-click-listener');
                                }
                            }
                        }
                    });

                    // Reset all non-active slides to their initial state
                    document.querySelectorAll('.media-carousel-item').forEach(function (item) {
                        // Get the slide containing this item
                        const slide = item.closest('.swiper-slide');

                        // Check if this is in the active slide
                        const isActiveSlide = slide && slide.classList.contains('swiper-slide-active');

                        // Only reset non-active slides
                        if (!isActiveSlide) {
                            const img = item.querySelector('img');
                            const playBtn = item.querySelector('.media-carousel-play');
                            const overlay = item.querySelector('.bg-opacity-60');
                            const iframe = item.querySelector('.media-carousel-iframe');

                            // Show the thumbnail and play button
                            if (img) img.style.display = '';
                            if (playBtn) playBtn.style.display = '';
                            if (overlay) overlay.style.display = '';

                            // Hide the iframe
                            if (iframe) {
                                iframe.src = '';
                                iframe.style.display = 'none';
                            }

                            // Reset all state flags
                            item.classList.remove('video-manually-played');
                            item.classList.remove('video-auto-played');
                            item.dataset.playing = 'false';
                        }
                    });
                },
                slideChangeTransitionEnd: function () {
                    // After slide transition is complete, check for videos in active slide
                    const activeSlide = document.querySelector('.media-carousel-swiper .swiper-slide-active');
                    if (activeSlide) {
                        // Get the media item in the active slide
                        const mediaItem = activeSlide.querySelector('.media-carousel-item');
                        if (mediaItem) {
                            // Check if this is an autoplay video
                            const shouldAutoplay = mediaItem.dataset.autoplay === 'true';
                            const showPlayBtn = mediaItem.dataset.showPlayBtn === 'true';
                            const videoSource = mediaItem.dataset.source;

                            // Only proceed if there's a video source
                            if (videoSource) {
                                // Get elements
                                const iframe = mediaItem.querySelector('.media-carousel-iframe');
                                const img = mediaItem.querySelector('img');
                                const playBtn = mediaItem.querySelector('.media-carousel-play');
                                const overlay = mediaItem.querySelector('.bg-opacity-60');

                                // For autoplay videos without play button, start playing automatically
                                if (shouldAutoplay && !showPlayBtn) {
                                    // Small delay to ensure DOM is ready
                                    setTimeout(() => {
                                        // Hide image and overlay
                                        if (img) img.style.display = 'none';
                                        if (overlay) overlay.style.display = 'none';
                                        if (playBtn) playBtn.style.display = 'none';

                                        // Only handle Vimeo videos
                                        if (iframe && videoSource && videoSource.includes('vimeo.com')) {
                                            let embedUrl = '';
                                            let videoId = null;

                                            // Get the source URL from data-src attribute
                                            const iframeSrc = iframe.dataset.src || videoSource;

                                            // Extract Vimeo video ID
                                            const videoIdMatch = iframeSrc.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                                            if (videoIdMatch && videoIdMatch[1]) {
                                                videoId = videoIdMatch[1];

                                                // Create Vimeo embed URL with custom parameters for autoplay:
                                                // - autoplay=1: Start playing automatically
                                                // - background=1: Hide controls, logo, etc.
                                                // - muted=1: Mute sound (required for autoplay)
                                                // - controls=0: Hide controls
                                                embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&background=1&muted=1&controls=0`;

                                                // Add loop parameter if needed
                                                if (mediaItem.dataset.loop === 'true') {
                                                    embedUrl += '&loop=1';
                                                }
                                            }

                                            // Store the video ID and playing state
                                            mediaItem.dataset.videoId = videoId;
                                            mediaItem.dataset.playing = 'true';

                                            // Only set the src when we're ready to play
                                            iframe.src = embedUrl;
                                            iframe.style.display = 'block';

                                            // Add click event to toggle play/pause if not already added
                                            if (!iframe.hasAttribute('data-click-listener')) {
                                                iframe.setAttribute('data-click-listener', 'true');

                                                // Use a transparent overlay for click events
                                                const clickOverlay = document.createElement('div');
                                                clickOverlay.className = 'absolute inset-0 z-40 cursor-pointer video-click-overlay';
                                                mediaItem.appendChild(clickOverlay);

                                                clickOverlay.addEventListener('click', () => {
                                                    // Toggle play/pause using Vimeo's postMessage API
                                                    const isPlaying = mediaItem.dataset.playing === 'true';

                                                    if (isPlaying) {
                                                        // Pause the video
                                                        iframe.contentWindow.postMessage(JSON.stringify({
                                                            method: 'pause'
                                                        }), '*');
                                                        mediaItem.dataset.playing = 'false';
                                                    } else {
                                                        // Play the video
                                                        iframe.contentWindow.postMessage(JSON.stringify({
                                                            method: 'play'
                                                        }), '*');
                                                        mediaItem.dataset.playing = 'true';
                                                    }
                                                });
                                            }

                                            // Mark this as an auto-played video
                                            mediaItem.classList.add('video-auto-played');
                                        }
                                    }, 300);
                                } else {
                                    // For videos with play button, ensure the play button is visible and ready
                                    if (playBtn) {
                                        playBtn.style.display = '';

                                        // Make sure the play button is clickable
                                        if (!playBtn.hasAttribute('data-click-listener-added')) {
                                            playBtn.setAttribute('data-click-listener-added', 'true');

                                            // Remove any existing click event listeners
                                            const newPlayBtn = playBtn.cloneNode(true);
                                            playBtn.parentNode.replaceChild(newPlayBtn, playBtn);

                                            // Add a fresh click event listener
                                            newPlayBtn.addEventListener('click', function () {
                                                const container = this.closest('.media-carousel-item');
                                                if (container) {
                                                    // Call the playVideo function from media-carousel.js
                                                    if (typeof window.playVideo === 'function') {
                                                        window.playVideo(container);
                                                    } else {
                                                        // Fallback implementation if playVideo function is not available
                                                        const videoSource = container.dataset.source;
                                                        const iframe = container.querySelector('.media-carousel-iframe');
                                                        const img = container.querySelector('img');
                                                        const overlay = container.querySelector('.bg-opacity-60');

                                                        // Hide elements
                                                        this.style.display = 'none';
                                                        if (img) img.style.display = 'none';
                                                        if (overlay) overlay.style.display = 'none';

                                                        if (iframe && videoSource) {
                                                            // Extract Vimeo video ID
                                                            const videoIdMatch = videoSource.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                                                            if (videoIdMatch && videoIdMatch[1]) {
                                                                const videoId = videoIdMatch[1];
                                                                const embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&background=1&muted=0&controls=0`;

                                                                iframe.src = embedUrl;
                                                                iframe.style.display = 'block';
                                                                container.dataset.playing = 'true';
                                                            }
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }
}

$(document).ready(function ($) {
    initializeMoreWorkSwiper();
    initializeMediaCarousel();
});

// Re-initialize on resize to recalculate padding and width
let resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        // Update slide widths immediately for smoother resize experience
        const containerMaxWidth = 1728;
        const windowWidth = window.innerWidth;
        const mainSlideWidth = Math.min(windowWidth, containerMaxWidth) * 0.85;

        document.querySelectorAll('.media-carousel-swiper .swiper-slide').forEach(slide => {
            slide.style.width = `${mainSlideWidth}px`;
        });

        // Then reinitialize carousels for complete update
        initializeMoreWorkSwiper();
        initializeMediaCarousel();
    }, 250); // Debounce resize event
});

$(window).on('click', function () {
});

$(window).on('scroll', function () {
});

document.addEventListener("DOMContentLoaded", function () {
	const blockCaseStudies = document.querySelectorAll(".blk-case-study");

	blockCaseStudies.forEach((blockCaseStudy) => {
		const buttons = blockCaseStudy.querySelector(".swiper-buttons");
		const swiper = blockCaseStudy.querySelector(".swiper");

		if (!swiper) return;

		const swiperConfig = {
			slidesPerView: 1.3,
			spaceBetween: 16,
			loop: true,
			autoplay: {
				delay: 3000,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.3,
					spaceBetween: 24,
				},
				992: {
					slidesPerView: 2.7,
					spaceBetween: 24,
				},
			},
		};

		if (buttons) {
			swiperConfig.navigation = {
				prevEl: buttons.querySelector('.swiper-button-prev'),
				nextEl: buttons.querySelector('.swiper-button-next'),
			};
		}

		const swiperInstance = new Swiper(swiper, swiperConfig);
	});
});
